import { useToggleLayoutPlatform } from '@/utils/zustand/providers/toggle-layout-platform-provider';

const useActiveTreeStructure = () => {
    const layoutPlatformActivated = useToggleLayoutPlatform((state) => state.isActive);

    return { isTreeStructureActivated: layoutPlatformActivated };
};

export default useActiveTreeStructure;
